import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import commonPt from "./locales/pt/common.json";
import landingHomePt from "./locales/pt/landing-home.json";
import landingEventsPt from "./locales/pt/landing-events.json";
import producerLandingPt from "./locales/pt/producer-landing.json";
import producerLandingFeaturesPt from "./locales/pt/producer-landing-features.json";
import landingBlogFaqPt from "./locales/pt/landing-blog-faq.json";
import eventDetailPt from "./locales/pt/event-detail.json";
import checkoutPt from "./locales/pt/checkout.json";
import buyerPt from "./locales/pt/buyer.json";
import accountPt from "./locales/pt/account.json";
import staffPt from "./locales/pt/staff.json";
import producerCommonPt from "./locales/pt/producer-common.json";
import producerDashboardPt from "./locales/pt/producer-dashboard.json";
import producerEventFormPt from "./locales/pt/producer-event-form.json";
import producerCheckoutQuestionsPt from "./locales/pt/producer-checkout-questions.json";
import producerSalesPt from "./locales/pt/producer-sales.json";
import producerCheckinPt from "./locales/pt/producer-checkin.json";
import producerFinancialPt from "./locales/pt/producer-financial.json";
import producerCertificatesPt from "./locales/pt/producer-certificates.json";
import producerMessagesPt from "./locales/pt/producer-messages.json";
import producerOrgPt from "./locales/pt/producer-org.json";
import schedulePt from "./locales/pt/schedule.json";
import producerSchedulePt from "./locales/pt/producer-schedule.json";

import commonEn from "./locales/en/common.json";
import landingHomeEn from "./locales/en/landing-home.json";
import landingEventsEn from "./locales/en/landing-events.json";
import producerLandingEn from "./locales/en/producer-landing.json";
import producerLandingFeaturesEn from "./locales/en/producer-landing-features.json";
import landingBlogFaqEn from "./locales/en/landing-blog-faq.json";
import eventDetailEn from "./locales/en/event-detail.json";
import checkoutEn from "./locales/en/checkout.json";
import buyerEn from "./locales/en/buyer.json";
import accountEn from "./locales/en/account.json";
import staffEn from "./locales/en/staff.json";
import producerCommonEn from "./locales/en/producer-common.json";
import producerDashboardEn from "./locales/en/producer-dashboard.json";
import producerEventFormEn from "./locales/en/producer-event-form.json";
import producerCheckoutQuestionsEn from "./locales/en/producer-checkout-questions.json";
import producerSalesEn from "./locales/en/producer-sales.json";
import producerCheckinEn from "./locales/en/producer-checkin.json";
import producerFinancialEn from "./locales/en/producer-financial.json";
import producerCertificatesEn from "./locales/en/producer-certificates.json";
import producerMessagesEn from "./locales/en/producer-messages.json";
import producerOrgEn from "./locales/en/producer-org.json";
import scheduleEn from "./locales/en/schedule.json";
import producerScheduleEn from "./locales/en/producer-schedule.json";

// Namespaces da landing e da aplicacao. pt e a fonte de
// verdade; en e preenchido na Fase 5 do plano. Ate la, fallbackLng garante que
// chave ausente em en cai pro texto pt em vez de mostrar a chave crua.
i18n.use(initReactI18next).init({
  resources: {
    pt: {
      common: commonPt,
      landingHome: landingHomePt,
      landingEvents: landingEventsPt,
      producerLanding: producerLandingPt,
      producerLandingFeatures: producerLandingFeaturesPt,
      landingBlogFaq: landingBlogFaqPt,
      eventDetail: eventDetailPt,
      checkout: checkoutPt,
      buyer: buyerPt,
      account: accountPt,
      staff: staffPt,
      producerCommon: producerCommonPt,
      producerDashboard: producerDashboardPt,
      producerEventForm: producerEventFormPt,
      producerCheckoutQuestions: producerCheckoutQuestionsPt,
      producerSales: producerSalesPt,
      producerCheckin: producerCheckinPt,
      producerFinancial: producerFinancialPt,
      producerCertificates: producerCertificatesPt,
      producerMessages: producerMessagesPt,
      producerOrg: producerOrgPt,
      schedule: schedulePt,
      producerSchedule: producerSchedulePt,
    },
    en: {
      common: commonEn,
      landingHome: landingHomeEn,
      landingEvents: landingEventsEn,
      producerLanding: producerLandingEn,
      producerLandingFeatures: producerLandingFeaturesEn,
      landingBlogFaq: landingBlogFaqEn,
      eventDetail: eventDetailEn,
      checkout: checkoutEn,
      buyer: buyerEn,
      account: accountEn,
      staff: staffEn,
      producerCommon: producerCommonEn,
      producerDashboard: producerDashboardEn,
      producerEventForm: producerEventFormEn,
      producerCheckoutQuestions: producerCheckoutQuestionsEn,
      producerSales: producerSalesEn,
      producerCheckin: producerCheckinEn,
      producerFinancial: producerFinancialEn,
      producerCertificates: producerCertificatesEn,
      producerMessages: producerMessagesEn,
      producerOrg: producerOrgEn,
      schedule: scheduleEn,
      producerSchedule: producerScheduleEn,
    },
  },
  lng: "pt",
  fallbackLng: "pt",
  defaultNS: "common",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
